import { normalizeStore, type StoreType } from "./BotFiltersOnboardingModal.utils";

export type AdminStoreOption = {
  normalizedId: string;
  normalizedAddress: string;
  normalizedPostalCode: string;
  normalizedGeo?: { lat: number; long: number };
};

export function normalizeAdminStoreIds(
  storeIds: string[],
  retailer: string,
): string[] {
  const normalized = storeIds
    .map((storeId) => storeId.trim())
    .filter(Boolean)
    .map((storeId) =>
      retailer === "home_depot"
        ? storeId.replace(/^0+/, "") || storeId
        : storeId,
    );

  return [...new Set(normalized)];
}

export function buildAdminStoreOptions(
  stores: unknown[] | null | undefined,
  retailer: string
): AdminStoreOption[] {
  if (!stores?.length) return [];
  return (stores as StoreType[])
    .map((store) => {
      const normalized = normalizeStore(store, retailer);
      return {
        normalizedId: normalized.normalizedId,
        normalizedAddress: normalized.normalizedAddress,
        normalizedPostalCode: normalized.normalizedPostalCode,
        normalizedGeo: normalized.normalizedGeo,
      };
    })
    .filter((store) => store.normalizedId);
}

export function filterAdminStores(
  options: AdminStoreOption[],
  query: string,
): AdminStoreOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter(
    (store) =>
      store.normalizedId.toLowerCase().includes(q) ||
      store.normalizedAddress.toLowerCase().includes(q),
  );
}
